export const TESTE_OP_01 = 'TESTE_OP_01';
export const TESTE_OP_02 = 'TESTE_OP_02';

export function testeFunction(index) {
  return {
    type: TESTE_OP_01,
    index,
  };
}

export function teste2Function(data, index) {
  return {
    type: TESTE_OP_02,
    testeObj2: data,
    index,
  };
}

